import classNames from "classnames";
import { observer } from "mobx-react";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { Anchor } from "@/components/anchor";
import { IconOrder } from "@/components/icons/icon-order";
import { IconProduct } from "@/components/icons/icon-product";
import { SellerPageRouter } from "@/modules/seller/page-router.props";
import { useStores } from "@/stores";
import { normalizeUrl } from "@/utils/helper";

export const BottomNav = observer(() => {
  const { accountStore } = useStores();
  const router: SellerPageRouter = useRouter();

  const MENU_NAV = useMemo(() => {
    return [
      {
        title: "Produk",
        href: `/${router.query.seller}`,
        icon: <IconProduct />,
      },
      {
        title: "Pesanan",
        href: `/${router.query.seller}/order`,
        icon: <IconOrder />,
      },
    ];
  }, [router.query.seller]);

  const isTabNavActive = useCallback(
    (menu: string) => {
      if (
        normalizeUrl(router.asPath) === menu ||
        (normalizeUrl(router.asPath).includes(menu) &&
          menu !== `/${router.query.seller}`)
      ) {
        return true;
      }
      return false;
    },
    [router.asPath, router.query.seller]
  );
  return (
    !router.query.fromapp ?
      <nav className="fixed flex items-center bottom-0 border-t border-t-gray-400 w-[100vw] sm:max-w-screen-mobile h-[60px] shadow-md bg-white">
        {MENU_NAV.map((menu, index) => {
          const isActiveTab = isTabNavActive(menu.href);
          return (
            <Anchor
              key={index}
              href={menu.href}
              className={classNames(
                "flex flex-1 flex-col items-center justify-center h-full text-label-md",
                isActiveTab ? "text-primary-700 font-bold" : "text-custombg"
              )}
              id={
                menu.title === "Produk"
                  ? "bottom-nav-product-btn"
                  : menu.title === "Pesanan"
                    ? "bottom-nav-order-btn"
                    : ""
              }
            >
              {menu.title === "Produk" &&
                accountStore?.buyerAccount?.trading === true && (
                  <div className="border-2 bg-orange border-orange text-white rounded-2xl px-1 text-2xs absolute mb-9">
                    Grosir
                  </div>
                )}
              {menu.icon}
              {menu.title}
            </Anchor>
          );
        })}
      </nav>
      : <div />
  )
})